var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartAppointmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0396ACC6-2954-44A4-BD87-11239C2ED4BD@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "08---Consultas-Online",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-08-03-02",
    transform: "translate(-955.000000, -176.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(150.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Elements/Buttons/Primary/Label",
    transform: "translate(785.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICONS/Camera/Standard",
    transform: "translate(0.944470, 4.437500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9192875,0.891969524 L13.2630778,3.36467161 L13.2630778,2.56681877 C13.2630778,1.14920391 12.2862857,0 11.0813515,0 L2.1817263,0 C0.976792137,0 0,1.14920391 0,2.56681877 L0,10.5581812 C0,11.9757961 0.976792137,13.125 2.1817263,13.125 L11.0813515,13.125 C12.2862857,13.125 13.2630778,11.9757961 13.2630778,10.5581812 L13.2630778,9.76032839 L16.9192875,12.2330305 C17.6119856,12.7014749 18.1810525,12.3164521 18.1810525,11.3774242 L18.1810525,1.75185381 C18.1810525,0.808547914 17.6138037,0.423525098 16.9192875,0.891969524 Z",
    id: "lists/icon_camera-small"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartAppointmentIcon);
export default __webpack_public_path__ + "static/media/start-appointment-icon.c76074b40365697061b471289d8d6701.svg";
export { ForwardRef as ReactComponent };